import React from "react";
import "./PromoLayout.scss"
import arrowBlack from "../../../assets/arrow-black.svg"
import PromoSingleLayout from "./PromoSingleLayout";

const PromoLayout = ({ promos, onClick }) => {
    console.log(promos, "promos")
    return (
        <div className="PromoLayout">
            <div className="PromoLayout-header-content"><div className="promoheader-text">Special Offers</div>
                <div className='view-all-container'
                    onClick={onClick}
                >   <div className='view-all-text'>View All Offers</div>
                    <img alt='' src={arrowBlack} className='icon' /></div>
            </div>
            <PromoSingleLayout promos={promos} />
        </div>

    )
}
export default PromoLayout